import React, {useEffect, useState} from 'react';
import './ProjectsEstimate.scss';
import {useHistory, useParams} from 'react-router-dom';
import {mainPath} from '../../../routes/paths';
import ProjectsHero from '../../Components/Projects/ProjectsHero';
import ProjectsNewFile from '../../Components/Projects/ProjectsNew';
import ProjectsSearchPanel from '../../Components/Projects/ProjectsSearchPanel';
import ProjectsItem from '../../Components/Projects/ProjectsItem';
import SingleDocument from '../ProjectsDocuments/SingleDocument/SingleDocument';
import {IconButtonMUI} from '../../../shared';
import PopoverMui from '../../../shared/PopoverMui/PopoverMui';
import {ReactComponent as DownloadFile} from '../../../assets/icons/downloadFile.svg';
import {ReactComponent as TrashIcon} from '../../../assets/icons/trash.svg';
import {ReactComponent as Dots} from '../../../assets/icons/dots.svg';
import {ReactComponent as AddFileSvg} from '../../../assets/icons/addFile.svg';
import {ReactComponent as EyeSvg} from '../../../assets/icons/eye.svg';
import {ReactComponent as Edit2Svg} from '../../../assets/icons/edit-3.svg';

import {
    approveDoc,
    deleteDoc,
    deleteDocs,
    downloadDoc,
    downloadDocById,
    getDocument,
    getEstimates,
    rejectDoc,
    requestApproval,
    resetSingleDoc
} from '../../../redux/actions/documents/documentsActions';
import {useDispatch, useSelector} from 'react-redux';
import LoadPanel from '../../Components/LoadPanel';
import NoItems from '../../Components/NoItems';
import {mimeTypesBrowserSupport, PERMISSIONS} from '../../../helpers/constants';
import {notifySuccess} from '../../../helpers/notifySnack';
import {getProject} from '../../../redux/actions/projects/projectsActions';
import {acceptGeneralFormats, hasPermission} from '../../../helpers/functions';
import {useTranslation} from 'react-i18next';
import {closeModal, setModal, setModalData, showConfirmPopup} from '../../../redux/actions/app/appActions';
import {POPUPS} from '../../../redux/actions/app/appActionTypes';
import {downloadHandlerFiles, viewHandlerFiles} from "../../../helpers/files";

const ProjectsEstimate = () => {
    const profileMe = useSelector((state) => state.profile.profileMe);
    const {t} = useTranslation();

    const dispatch = useDispatch();

    const {
        estimates,
        singleDocument,
        singleDocumentLoading
    } = useSelector(({documents}) => documents);
    const {singleProject} = useSelector((state) => state.projects);
    const allowActions = singleProject?.status === 'active' || singleProject?.status === 'pause'
    const [showNewFile, setShowNewFile] = useState(false);

    const [anchorEl, setAnchorEl] = React.useState(null);

    const [submitted, setSubmitted] = useState(false);
    const [searchVal, setSearchVal] = useState('');

    const handleClickAnchor = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleSearch = (value) => {
        setSearchVal(value);
        clearCheckboxes();
    };

    const handleClear = () => {
        setSearchVal('');
        clearCheckboxes();
    };

    const downloadAllHandler = () => {
        if (checkedItems.length) {
            dispatch(setModal(POPUPS.PREPARING_POPUP));

            dispatch(downloadDoc(checkedItems)).then((res) => {
                if (res.payload) {
                    const link = document.createElement('a');
                    link.href = URL.createObjectURL(res.payload.data);
                    link.download = 'items.zip';
                    document.body.appendChild(link);

                    link.click();

                    link.parentNode.removeChild(link);
                    dispatch(closeModal());
                } else {
                    dispatch(closeModal());
                }
            });
        }
    };

    const removeHandler = async (documentId) => {
        if (!submitted) {
            setSubmitted(true);
            const res = await dispatch(deleteDoc(id, documentId));

            if (res.payload) {
                setSubmitted(false);
                notifySuccess(t('all.successfully'));
                handleNavigate();
                await dispatch(getProject(id));
            } else {
                setSubmitted(false);
            }
        }
    };

    const removeHandlerAll = async () => {
        setSubmitted(true);
        const res = await dispatch(deleteDocs(id, checkedItems));
        if (res.payload) {
            setSubmitted(false);
            handleNavigate();
            notifySuccess(t('all.successfully'));
            await dispatch(getProject(id));
        } else {
            setSubmitted(false);
        }
    };

    const openState = Boolean(anchorEl);

    const history = useHistory();

    const {documentId, id} = useParams();

    const isSinglePage = documentId;

    const [checkedItems, setCheckedItems] = useState([]);

    const [isCheckAll, setIsCheckAll] = useState(false);

    const handleCheck = (id) => {
        setCheckedItems((prev) => (prev.includes(id) ? prev.filter((itemId) => itemId !== id) : [...prev, id]));
    };

    const handleCheckAll = () => {
        if (isCheckAll) {
            setCheckedItems([]);
        } else {
            setCheckedItems(filteredEstimates.map((doc) => doc.id));
        }
        setIsCheckAll(!isCheckAll);
    };

    const handleNavigate = () => {
        history.push(mainPath.projectsEstimate.replace(':id', id));
        setShowNewFile(false);
    };
    const handleNavigateNew = () => {
        setShowNewFile(true);
    };

    const clearCheckboxes = () => {
        setIsCheckAll(false);
        setCheckedItems([]);
    };

    const redirectUrl = mainPath.projectEstimate;

    useEffect(() => {
        const fetchData = async () => {
            await dispatch(getEstimates(id, 'estimate'));
        };
            fetchData();
        return () => {
            setShowNewFile(false);
        }
    }, [id]);
    useEffect(() => {
        const fetchFunc = async () => {
            const res = await dispatch(getDocument(id, documentId));
            if (res?.error?.response?.status === 409) {
                handleNavigate();
            }
        };
        if (documentId) {
            fetchFunc();
        }

        return () => {
            if (documentId) {
                dispatch(resetSingleDoc());
            }
        };
    }, [documentId, id]);

    function getDocumentWord(count) {
        if (count % 100 >= 11 && count % 100 <= 19) {
            return t('ProjectsEstimate.documents'); // виняток для чисел від 11 до 19
        }

        switch (count % 10) {
            case 1:
                return t('ProjectsEstimate.document'); // 1 документ
            case 2:
            case 3:
            case 4:
                return t('ProjectsEstimate.documentss'); // 2, 3, 4 документи
            default:
                return t('ProjectsEstimate.documents'); // 5-9, 0 документів
        }
    }

    const filteredEstimates = estimates.items.filter(
        (doc) => doc.name.toLowerCase().includes(searchVal.toLowerCase())
    );

    const requestApproveHandler = async () => {
        const res = await dispatch(requestApproval(id, documentId));
        if (res.payload) {
            const responseDoc = await dispatch(getDocument(id, documentId));
            if (responseDoc.payload) {
                const response = await dispatch(getEstimates(id, 'estimate'));
                if (response.payload) {
                    notifySuccess(t('all.docRequest'));
                }
            }
        }
    };
    const requestApproveHandlerDocId = async (docId) => {
        let dId = documentId ?? docId;

        if (submitted) return;
        setSubmitted(true);
        const res = await dispatch(requestApproval(id, dId));
        if (res.payload) {
            notifySuccess(t('all.successfully'));
            setSubmitted(false);
        }
        setSubmitted(false);
    };

    const approveHandler = async () => {
        const res = await dispatch(approveDoc(id, documentId));

        if (res.payload) {
            const responseDoc = await dispatch(getDocument(id, documentId));
            if (responseDoc.payload) {
                const response = await dispatch(getEstimates(id, 'estimate'));
                if (response.payload) {
                    notifySuccess(t('all.docApprove'));
                }
            }
        }
    };

    const removeHandlerSingleRedux = (documentId) => {
        dispatch(
            showConfirmPopup({
                visible: true,
                confirmCallback: () => removeHandler(documentId)
            })
        );
    };
    const removeHandlerMultipleRedux = () => {
        if (checkedItems.length) {
            dispatch(
                showConfirmPopup({
                    visible: true,
                    confirmCallback: () => removeHandlerAll()
                })
            );
        }
    };
    const rejectHandler = async () => {
        const res = await dispatch(rejectDoc(id, documentId));

        if (res.payload) {
            const responseDoc = await dispatch(getDocument(id, documentId));
            if (responseDoc.payload) {
                const response = await dispatch(getEstimates(id, 'estimate'));
                if (response.payload) {
                    notifySuccess(t('all.docReject'));
                }
            }
        }
    };
    const rejectHandlerRedux = () => {
        dispatch(
            showConfirmPopup({
                visible: true,
                title: t('SingleDocument.reject'),
                text: t('all.docReallyReject3'),
                confirmCallback: () => rejectHandler()
            })
        );
    };

    const acceptHandlerRedux = () => {
        dispatch(
            showConfirmPopup({
                visible: true,
                title: t('SingleDocument.approve'),
                text: t('all.docReallyApprove3'),
                confirmCallback: () => approveHandler()
            })
        );
    };

    const downloadPermission = hasPermission(PERMISSIONS.ESTIMATE_LIST, profileMe?.permissions ?? []);
    const addPermission = hasPermission(PERMISSIONS.ESTIMATE_CREATE, profileMe?.permissions ?? []);
    const trashPermission = hasPermission(PERMISSIONS.ESTIMATE_REMOVE, profileMe?.permissions ?? []);
    const requestPermission = hasPermission(PERMISSIONS.ESTIMATE_REQUEST, profileMe?.permissions ?? []);
    const permissionChangeStatus = hasPermission(PERMISSIONS.DOCUMENT_STATUS_EDIT, profileMe?.permissions ?? []);

    const isSupportView = (mime) => mimeTypesBrowserSupport?.includes(mime);

    const changeStatus = () => {
        dispatch(setModal(POPUPS.STATUS_DOC));
        dispatch(setModalData({
            id: singleDocument.id,
            projectId: singleProject.id,
            paymentStatus: singleDocument.paymentStatus,
            isSinglePage: true
        }))
    }


    console.log(addPermission);

    return (
        <div className={'projects__documents'}>
            {estimates.loading ? (
                <LoadPanel noBg={true} circleSize={40} staticPos={true}/>
            ) : (
                <>
                    <ProjectsHero
                        heading={t('ProjectsEstimate.heading')}
                        subHeading={`${estimates.items.length ?? 0} ${getDocumentWord(estimates.items.length ?? 0)}`}
                        showArrow={isSinglePage || showNewFile}
                        buttonHandler={handleNavigate}
                        buttons={
                            <>
                                {addPermission && !isSinglePage && !showNewFile && allowActions ? (
                                    <>
                                        <div className='projects__hero-icon projects__hero-icon-mob'
                                             onClick={handleNavigateNew}>
                                            <IconButtonMUI color={'default'}
                                                           title={t('ProjectsDocuments.no_items_button')}>
                                                <AddFileSvg/>
                                            </IconButtonMUI>
                                        </div>
                                    </>
                                ) : null}

                                {isSinglePage && (
                                    <>
                                        {downloadPermission && (
                                            <>
                                                {isSupportView(singleDocument?.mime) &&   <div
                                                    className='projects__hero-icon projects__hero-icon--purple'
                                                    onClick={() => {
                                                        const getFormat = singleDocument?.mime && acceptGeneralFormats[singleDocument.mime] ? acceptGeneralFormats[singleDocument.mime] : '';
                                                        const fileName = singleDocument?.name + ( getFormat?.[0] || '')
                                                        viewHandlerFiles({
                                                            file: singleDocument?.file,
                                                            name: fileName,
                                                            docId: singleDocument?.id,
                                                            projectId: singleProject?.id,
                                                        },dispatch);
                                                        handleClose();
                                                    }}
                                                >
                                                    <IconButtonMUI color={'default'}
                                                                   title={t('ProjectsDrawing.view_document')}>
                                                        <EyeSvg/>
                                                    </IconButtonMUI>
                                                </div>}
                                                <div
                                                    className='projects__hero-icon'
                                                    onClick={() =>
                                                    {
                                                        const getFormat = singleDocument?.mime && acceptGeneralFormats[singleDocument.mime] ? acceptGeneralFormats[singleDocument.mime] : '';
                                                        const fileName = singleDocument?.name + ( getFormat?.[0] || '')
                                                        downloadHandlerFiles({

                                                            file: singleDocument?.file,
                                                            name: fileName,
                                                            docId: singleDocument?.id,
                                                            projectId: singleProject?.id,
                                                        },dispatch)

                                                    }}
                                                >
                                                    <IconButtonMUI color={'default'}
                                                                   title={t('ProjectsDocuments.download')}>
                                                        <DownloadFile/>
                                                    </IconButtonMUI>
                                                </div>
                                            </>
                                        )}
                                        {trashPermission && allowActions && (
                                            <div
                                                className='projects__hero-icon'
                                                onClick={() => {
                                                    removeHandlerSingleRedux(singleDocument?.id);
                                                }}
                                            >
                                                <IconButtonMUI color={'default'} title={t('ProjectsDocuments.delete')}>
                                                    <TrashIcon/>
                                                </IconButtonMUI>
                                            </div>
                                        )}
                                        <div className='projects__hero-dropdown'>
                                            <Dots onClick={handleClickAnchor}/>
                                            <PopoverMui
                                                open={openState}
                                                handleClose={() => {
                                                    handleClose();
                                                }}
                                                anchorEl={anchorEl}
                                            >
                                                {downloadPermission ? (
                                                    <>
                                                        {isSupportView(singleDocument?.mime) &&  <div
                                                            className='projects__hero-link'
                                                            onClick={() => {
                                                                const getFormat = singleDocument?.mime && acceptGeneralFormats[singleDocument.mime] ? acceptGeneralFormats[singleDocument.mime] : '';
                                                                const fileName = singleDocument?.name + ( getFormat?.[0] || '')

                                                                viewHandlerFiles({
                                                                    file: singleDocument?.file,
                                                                    name: fileName,
                                                                    docId: singleDocument?.id,
                                                                    projectId: singleProject?.id,

                                                                },dispatch);
                                                                handleClose();
                                                            }}
                                                        >
                                                            <div className='projects__hero-circle'>
                                                                <EyeSvg/>
                                                            </div>
                                                            {t('ProjectsDrawing.view_document')}
                                                        </div>}
                                                        <div
                                                            className='projects__hero-link'
                                                            onClick={() => {
                                                                const getFormat = singleDocument?.mime && acceptGeneralFormats[singleDocument.mime] ? acceptGeneralFormats[singleDocument.mime] : '';
                                                                const fileName = singleDocument?.name + ( getFormat?.[0] || '')
                                                                downloadHandlerFiles({
                                                                    file: singleDocument?.file,
                                                                    name: fileName,
                                                                    docId: singleDocument?.id,
                                                                    projectId: singleProject?.id,
                                                                },dispatch);
                                                                handleClose();
                                                            }}
                                                        >
                                                            <div className='projects__hero-circle'>
                                                                <DownloadFile/>
                                                            </div>
                                                            {t('ProjectsDrawing.download_document')}
                                                        </div>
                                                    </>
                                                ) : null}
                                                {trashPermission && allowActions ? (
                                                    <div
                                                        className='projects__hero-link'
                                                        onClick={() => {
                                                            removeHandlerSingleRedux(documentId);
                                                            handleClose();
                                                        }}
                                                    >
                                                        <div className='projects__hero-circle'>
                                                            <TrashIcon/>
                                                        </div>
                                                        {t('ProjectsEstimate.delete')}
                                                    </div>
                                                ): null}
                                            </PopoverMui>
                                        </div>
                                    </>
                                )}
                            </>
                        }
                    />
                    {estimates.items.length && !showNewFile ? (
                        <>
                            {!isSinglePage ? (
                                <>
                                    <ProjectsSearchPanel
                                        searchVal={searchVal}
                                        handleSearch={handleSearch}
                                        handleClear={handleClear}
                                        downloadAllHandler={downloadAllHandler}
                                        handleChange={(e) => handleSearch(e.target.value)}
                                        isCheckAll={isCheckAll}
                                        handleCheckAll={handleCheckAll}
                                        checkedItems={checkedItems}
                                        removeHandlerAll={removeHandlerMultipleRedux}
                                        permissionTrash={trashPermission && allowActions}
                                        permissionDownload={downloadPermission}
                                        permissions={profileMe?.permissions}
                                    />

                                    <div className='projects__list'>
                                        {filteredEstimates.map((el) => {
                                            return (
                                                <ProjectsItem
                                                    key={el.id}
                                                    el={el}
                                                    checked={checkedItems.includes(el.id)}
                                                    onCheck={() => handleCheck(el.id)}
                                                    projectId={id}
                                                    redirectUrl={redirectUrl}
                                                    removeHandler={removeHandlerSingleRedux}
                                                    permissionTrash={trashPermission && allowActions}
                                                    permissionDownload={downloadPermission}
                                                    remindProject={true}
                                                    requestApproveHandler={requestApproveHandlerDocId}
                                                    remindPermission={requestPermission && allowActions}
                                                    isEstimate={true}
                                                    permissionChangeStatus={permissionChangeStatus}
                                                />
                                            );
                                        })}
                                    </div>
                                </>
                            ) : (
                                <SingleDocument
                                    handleNavigate={handleNavigate}
                                    approveHandler={acceptHandlerRedux}
                                    singleDocument={singleDocument}
                                    singleDocumentLoading={singleDocumentLoading}
                                    requestApproveHandler={requestApproveHandler}
                                    rejectHandler={rejectHandlerRedux}
                                    isEstimate={true}
                                />
                            )}
                        </>
                    ) : (
                        <>
                            {!showNewFile && (
                                <NoItems
                                    description={t('ProjectsEstimate.description')}
                                    title={t('ProjectsEstimate.title')}
                                    handleNavigate={handleNavigateNew}
                                    buttonText={t('ProjectsEstimate.buttonText')}
                                    center={'center'}
                                    disabled={!allowActions || !addPermission}
                                />
                            )}
                        </>
                    )}
                </>
            )}
            {showNewFile && <ProjectsNewFile type={'estimate'} setShowNewFile={setShowNewFile}/>}
        </div>
    );
};

export default ProjectsEstimate;
